/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Data Imports */

import { Typography } from "@material-ui/core";
import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  iconImage: {
    height: 100,
    width: 100,
    [theme.breakpoints.down("sm")]: {
      height: 76,
      width: 76,
    },
  },
  iconTextRow: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    background: "#ffffff",
    gap: "1rem",
    boxShadow: "none",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "flex-start",
  },
  heading: {
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: "1.96rem",
    color: "#212121",
    width: "100%",
    marginBottom: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      fontWeight: 500,
    },
  },
  subHeading: {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#666666",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      wordBreak: "break-word",
    },
  },
}));

const IconTextHeadingCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={`${classes.iconTextRow} ${props.className}`}>
        <img
          alt={AppConfig.imageAltText}
          loading="lazy"
          referrerPolicy="no-referrer"
          height={120}
          width={120}
          src={props.icon ? props.icon : "/images/icons/config/area.svg"}
          className={classes.iconImage}
        />
        <div className={classes.text}>
          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            {props.title ? props.title : "Modern"}
          </Typography>
          <Typography
            variant="body2"
            component="span"
            className={classes.subHeading}
          >
            {props.description ? props.description : "Scientific and definitive construction solutions"}
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IconTextHeadingCard;
